import { render, staticRenderFns } from "./Calltrackingnumbers.vue?vue&type=template&id=2f5bd8e0&"
import script from "./Calltrackingnumbers.vue?vue&type=script&lang=js&"
export * from "./Calltrackingnumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports